var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import clsx from 'clsx';
import React, { Fragment, useContext } from 'react';
import { createStyles, lighten, makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import ExactaTableContext from '../../context/ExactaTableContext';
import SelectedFilters from '../SelectedFilters';
import AdditionalFilters from './AdditionalFilters';
import ViewColumns from './ViewColumns';
import { useSelector } from 'react-redux';
import { processFullSearchIdsList } from '../../store/selectors/process';
import ProcessSearchContext from '../../context/process-search-context';
import styled from 'styled-components';
var useToolbarStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(1),
        },
        highlight: theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
        title: {
            display: 'flex',
            flexDirection: 'row',
            flex: '1 1 100%',
        },
        filtersToolBar: {
            backgroundColor: '#efefef',
            border: '1px dotted grey',
        },
    });
});
var StyledLink = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #0645ad;\n  text-decoration: underline;\n  cursor: pointer;\n  margin-left: 6px !important;\n"], ["\n  color: #0645ad;\n  text-decoration: underline;\n  cursor: pointer;\n  margin-left: 6px !important;\n"])));
var ExactaTableToolbar = function (_a) {
    var _b;
    var selected = _a.selected, numSelected = _a.numSelected, title = _a.title, actions = _a.actions, selectedActions = _a.selectedActions, filters = _a.filters, handleViewColumnChange = _a.handleViewColumnChange, onDeleteFilter = _a.onDeleteFilter, additionalFilters = _a.additionalFilters, onApplyAdditionalFilters = _a.onApplyAdditionalFilters;
    var _c;
    var classes = useToolbarStyles({});
    var exactaTableContext = useContext(ExactaTableContext);
    var modelAlias = exactaTableContext.modelAlias, columns = exactaTableContext.columns, totalRows = exactaTableContext.totalRows, selectAll = exactaTableContext.selectAll, handleSelectAll = exactaTableContext.handleSelectAll, handleClearSelection = exactaTableContext.handleClearSelection;
    var psContext = useContext(ProcessSearchContext);
    var allIds = useSelector(processFullSearchIdsList(modelAlias, psContext.name));
    return (React.createElement(Fragment, null,
        React.createElement(Toolbar, { className: clsx(classes.root, (_b = {},
                _b[classes.highlight] = numSelected > 0,
                _b)) },
            numSelected > 0 ? (React.createElement("div", { className: classes.title },
                React.createElement(Typography, { color: "inherit", variant: "subtitle1", component: "div" },
                    selectAll ? totalRows : numSelected,
                    " rows selected"),
                selectAll ? (React.createElement(StyledLink, { variant: "subtitle1", onClick: handleClearSelection }, "Clear Selection")) : (React.createElement(StyledLink, { variant: "subtitle1", onClick: handleSelectAll }, "Select All " + totalRows + " rows")))) : (React.createElement(Typography, { className: classes.title, variant: "h6", id: "tableTitle", component: "div" }, title)),
            numSelected > 0 ? (React.createElement(Fragment, null,
                React.createElement(Tooltip, { title: "Delete" },
                    React.createElement(IconButton, { "aria-label": "delete" },
                        React.createElement(DeleteIcon, null))), (_c = selectedActions) === null || _c === void 0 ? void 0 :
                _c.map(function (Action, index) {
                    return (React.createElement(Action, { key: "table-action-" + index, selected: selectAll ? allIds : selected }));
                }))) : (React.createElement(Fragment, null,
                React.createElement(AdditionalFilters, { additionalFilters: additionalFilters, onApplyAdditionalFilters: onApplyAdditionalFilters }),
                React.createElement(ViewColumns, { columns: columns, handleViewColumnChange: handleViewColumnChange }),
                actions.map(function (Action, index) {
                    return React.createElement(Action, { key: "table-action-" + index });
                })))),
        Object.keys(filters).length > 0 && (React.createElement(Toolbar, { className: classes.filtersToolBar },
            React.createElement(Typography, null, "Filters: "),
            React.createElement(SelectedFilters, { filters: filters, handleDeleteFilter: onDeleteFilter })))));
};
export default ExactaTableToolbar;
var templateObject_1;
//# sourceMappingURL=ExactaTableToolbar.js.map